import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PercentIndicatorComponent } from '@features/percent-indicator/percent-indicator.component';

import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { MoneyPipe } from '@shared/pipes/money.pipe';
import { RoundPipe } from '@shared/pipes/round.pipe';

export interface AnalyticData {
  differenceAmount?: number;
  differencePerc: number;
  differenceUnit?: number | string;
  title: string;
  topTitle?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, PercentIndicatorComponent, RoundPipe, MoneyPipe],
  selector: 'aux-trial-insights-finance-analytic-card',
  template: `
    <div
      class="grid h-[100px] w-full grid-cols-2 items-center border border-aux-gray-dark bg-aux-gray-light"
    >
      <div class="px-3 text-aux-blue-dark">{{ data.title }}</div>
      <div class="flex h-full flex-col justify-center bg-white px-3">
        @if (data.topTitle && (data.differenceAmount || data.differenceUnit)) {
          <p
            class="overflow-hidden text-ellipsis whitespace-nowrap text-right"
            [auxTooltip]="data.topTitle"
          >
            {{ data.topTitle }}
          </p>
        }
        @if (data.differenceAmount) {
          <p class="text-right">{{ data.differenceAmount | money }}</p>
        }
        @if (data.differenceUnit) {
          <p class="text-right">{{ data.differenceUnit | round: 2 }}</p>
        }
        <aux-percent-indicator [value]="data.differencePerc" />
      </div>
    </div>
  `,
})
export class TrialInsightsFinanceAnalyticCardComponent {
  @Input() data!: AnalyticData;
}
